import { useState, useEffect, useRef } from "react";

export function useDebouncedIncrement(depsKey, delayMs = 500) {
  const [trigger, setTrigger] = useState(0);
  const timerRef = useRef(null);
  const isFirstRef = useRef(true);

  useEffect(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    const delay = isFirstRef.current ? 0 : delayMs;
    isFirstRef.current = false;
    timerRef.current = setTimeout(() => {
      setTrigger((n) => n + 1);
      timerRef.current = null;
    }, delay);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [depsKey, delayMs]);

  return trigger;
}
